import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

const { dev } = routes;

export const devRoutes: RouteRender[] = [
  lazyView(dev.menu, () => import("./dev").then((m) => ({ default: m.DevPage })), "Dev Menu"),
  lazyView(dev.logs, () => import("./logs/dev-logs").then((m) => ({ default: m.DevLogsPage })), "Logs"),
  lazyView(dev.time, () => import("./time/dev-time").then((m) => ({ default: m.DevTimePage })), "Time Settings"),
  lazyView(dev.env, () => import("./env/dev-env").then((m) => ({ default: m.DevEnvPage })), "Env Settings"),
  lazyView(
    dev.store,
    () => import("./store/dev-store").then((m) => ({ default: m.DevStorePage })),
    () => "Store Settings",
  ),
  lazyView(
    dev.mapStart,
    () => import("./map-start/dev-map-start").then((m) => ({ default: m.DevMapStartPage })),
    "Map Start",
  ),
  lazyView(
    dev.localExpenses,
    () => import("./local-expenses/dev-local-expenses-page"),
    () => "Local Expenses",
  ),
];
